// src/firebase.js
import { initializeApp } from "firebase/app";
import { getAnalytics } from "firebase/analytics";
import { getAuth } from "firebase/auth";
import { getFirestore } from "firebase/firestore";

// Your Firebase config
const firebaseConfig = {
  apiKey: "AIzaSyCe0WYuHeR2EKMiQMJr-T-VeioiHkuzk00",
  authDomain: "set-trainer.firebaseapp.com",
  projectId: "set-trainer",
  storageBucket: "set-trainer.appspot.com",
  messagingSenderId: "277429649141",
  appId: "1:277429649141:web:95854af149088cde168fbc",
  measurementId: "G-YLL9TFGZ27"
};

// 1️⃣ Initialize app first
const app = initializeApp(firebaseConfig);

// 2️⃣ Initialize services using app
const auth = getAuth(app);
const db = getFirestore(app);
const analytics = getAnalytics(app);

// 3️⃣ Export everything
export { app, auth, db, analytics };
